import React, { useState, useEffect } from 'react';
import { createDirectLine } from 'botframework-webchat';
import { useLocation } from 'react-router-dom';
import KWebChat from './components/k-webchat/KWebChat';

async function getDirectLineToken(chatId) {
  const res = await fetch(
    `https://dewa-uaen-prd-rammas-appsvc-bot-fva0avabh8hkana5.uaenorth-01.azurewebsites.net/api/get_chat/${chatId}`,
    // `https://dewa-uaen-uat-rammas-appsvc-bot-dgfph5b4hsb6gtez.uaenorth-01.azurewebsites.net/api/get_chat/${chatId}`,
    // `https://dewa-uaen-dev-rammas-ddt-azure-bot-hag0gbhbanhahdfh.uaenorth-01.azurewebsites.net/api/get_chat/${chatId}`,

    { method: 'GET' }
  );
  const { token } = await res.json();
  return token;
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const WebChatContainerPlain = () => {
  const [directLine, setDirectLine] = useState();
  const query = useQuery();
  const chatId = query.get('chatId');
  let isArabic = query.get('isArabic');
  if (isArabic ==='true'){
    isArabic = true
  }else{
    isArabic = false
  }



  useEffect(() => {
    if (chatId && !directLine) {
      getDirectLineToken(chatId).then((token) => {
        const directLineConfig = { token };
        setDirectLine(createDirectLine(directLineConfig));
      });
    }
  }, [chatId, directLine]);

  return (
    <>
      {!!directLine && <KWebChat isArabic ={isArabic} directLine={directLine} />}
    </>
  );
};

export default WebChatContainerPlain;